export const TASK_TRACKER_MENU_NAME = 'taskTracker'
export const TASK_TRACKER_MENU_URL = '/task-tracker'

export const TASK_TRACKER_OVERDUE_NOTICE_TOOLTIP =
  'Кол-во просроченных задач: задачи со статусом «В работе», где вы исполнитель и дедлайн уже прошёл или сегодня.'

export const isTaskTrackerMenuItem = (item) => {
  const url = item?.url?.split('?')?.[0]
  return item?.name === TASK_TRACKER_MENU_NAME || url === TASK_TRACKER_MENU_URL
}

export const getMenuNoticeCountTooltip = (item) => {
  if (isTaskTrackerMenuItem(item)) {
    return TASK_TRACKER_OVERDUE_NOTICE_TOOLTIP
  }
  return undefined
}

/** Таск-трекер показывает и 0; остальные пункты — только noticeCount > 0 */
export const shouldShowMenuNoticeCount = (item) => {
  if (item?.noticeCount == null) return false
  if (isTaskTrackerMenuItem(item)) return true
  return item.noticeCount > 0
}
